import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';

const SkeletonLoader = ({minWidth, width, height, variant='primary', borderRadius }) => {
  if(variant === 'primary') return <SkeletonContainer data-qa-hook="skeleton-container" minWidth={minWidth} width={width} height={height} borderRadius={borderRadius} />;
  if(variant === 'secondary') return <SecondarySkeletonContainer width={width} height={height} borderRadius={borderRadius} />;
};

const shine = keyframes`
0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

const SkeletonContainer = styled.div`
${({ minWidth }) => minWidth && `min-width: ${minWidth}`};
  width: ${({ width }) => width || '130px'};
  height: ${({ height }) => height || '130px'};
  border-radius: ${({ borderRadius }) => borderRadius || '0.25rem'};
  background-color: #F5F5F5;
  background: linear-gradient(90deg, #F5F5F5 55%, #FFFFFF 75%, #F5F5F5 90%);
	background-size: 200% 100%;
	animation: ${shine} 1500ms linear 500ms infinite; 
`;

const SecondarySkeletonContainer = styled.div`
  width: ${({ width }) => width || '40rem'};
  height: ${({ height }) => height || '40rem'};
  border-radius: 0.25rem;
  background-color: #FFFFFF;
  background: linear-gradient(90deg, #FFFFFF 55%, #F5F5F5 75%, #FFFFFF 90%);
	background-size: 200% 100%;
	animation: ${shine} 1500ms linear 500ms infinite;   
`;

export default SkeletonLoader;

const { string } = PropTypes;

SkeletonLoader.propTypes = {
  width: string,
  height: string
};
